import {BackendApi} from "../../api/api.ts";

export class BusinessSettingsService {
    constructor(
        private settings: Record<string, any>,
        private readonly api: BackendApi
    ) {
    }

    public async refresh(): Promise<void> {
        const res = await this.api.Me__business__settings({})
        this.settings = res.settings
    }

    public getSetting(key: string): boolean {
        if (!this.settings.hasOwnProperty(key))
            throw new Error(`Setting ${key} does not exist`)
        return this.settings[key]
    }

    public async setSetting(key: string, value: any): Promise<void> {
        await this.api.Me__business__updateSetting({
            setting_name: key,
            setting_value: value,
        })

        this.settings[key] = value
    }
}
